<template>
  <div class="tf_comm">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'InputBase',
}
</script>

<style lang="scss" scoped>
.tf_comm{display:inline-block;overflow:hidden;position:relative;width:100%;padding-bottom:0;vertical-align:top;box-sizing:border-box}
.tf_comm .inner_input{overflow:hidden;height:38px;border-radius:$CONTENT_RADIUS;border:1px solid $DEFAULT_BORDER;font-weight:500;font-size:14px;background:none;background-color:$FORM_BG;color:$ACTIVE_TEXT;box-sizing:border-box;caret-color:$PRIMARY_COLOR}
.tf_comm input{display:block;width:100%;height:36px;padding:0px 14px 0;outline:none;border:0 none;font-weight:500;font-size:14px;line-height:36px;background:none;color:$ACTIVE_TEXT}

/* large */
.tf_comm.tf_large .inner_input{height:54px}
.tf_comm.tf_large input{height:52px;padding:0 20px;font-size:16px}
.tf_comm.tf_large button{padding:18px 10px}
.tf_comm.tf_large .area_util button:last-child{padding-right:20px}

/* autofill */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active{transition: background-color 5000s;-webkit-text-fill-color: $ACTIVE_TEXT !important}

/* placeholder */
.tf_comm input::-webkit-input-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
.tf_comm input:-moz-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
.tf_comm input::-moz-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
.tf_comm input:-ms-input-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
/* focus */
.tf_comm:focus-within .inner_input{border:1px solid $PRIMARY_COLOR}
/* count */
.desc_count{float:right;padding:6px 0 0;font-weight:600;font-size:12px;line-height:16px;color:$CONTENT_SUB_TEXT;text-align:right}
.desc_count em{font-weight:600;font-size:12px;line-height:16px}
.desc_count em.on{font-weight:700;color:$ACTIVE_TEXT}

/* error */
.tf_comm.tf_error{padding-bottom:0}
.tf_comm.tf_error .inner_input{border:1px solid $ERROR_COLOR;color:$ERROR_COLOR}
/* error placeholder */
.tf_comm.tf_error input::-webkit-input-placeholder{color:$ERROR_COLOR}
.tf_comm.tf_error input:-moz-placeholder{color:$ERROR_COLOR}
.tf_comm.tf_error input::-moz-placeholder{color:$ERROR_COLOR}
.tf_comm.tf_error input:-ms-input-placeholder{color:$ERROR_COLOR}
/* error focus */
.tf_comm.tf_error:focus-within .inner_input{border:1px solid $PRIMARY_COLOR}
/* error focus placeholder */
.tf_comm.tf_error:focus-within input::-webkit-input-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
.tf_comm.tf_error:focus-within input:-moz-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
.tf_comm.tf_error:focus-within input::-moz-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
.tf_comm.tf_error:focus-within input:-ms-input-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT}
/* error desc */
.desc_error{padding:0 0 6px;font-weight:500;font-size:14px;line-height:24px;color:$ERROR_COLOR;text-align:left}
.desc_error .icon_emoji{display:inline-block;margin-right:8px;vertical-align:top}

/* disabled - placeholder */
.tf_comm.disabled input::-webkit-input-placeholder{color:$PLACEHOLDER_TEXT}
.tf_comm.disabled input:-moz-placeholder{color:$PLACEHOLDER_TEXT}
.tf_comm.disabled input::-moz-placeholder{color:$PLACEHOLDER_TEXT}
.tf_comm.disabled input:-ms-input-placeholder{color:$PLACEHOLDER_TEXT}

/* disabled */
.tf_comm.disabled:hover,
.tf_comm.disabled input:hover{cursor:no-drop}
.tf_comm.disabled:focus-within input,
.tf_comm.disabled .inner_input{border-color:$DISABLED_BORDER;background-color:$DISABLED_BG}
.tf_comm.disabled input:disabled{color:$DISABLED_TEXT}

/* slot */
.tf_has_slot.tf_comm.disabled .inner_input{color:$DISABLED_TEXT}
.tf_has_slot .inner_input{padding-left:14px;font-weight:600;font-size:14px;line-height:36px;color:$ACTIVE_TEXT}
.tf_has_slot input{padding-left:4px}

/* util */
.tf_has_util .inner_input{display:flex;flex-wrap:nowrap}
.tf_has_util input{flex-grow:1}
.area_util{display:none;align-items:flex-end;line-height:16px}
/* .area_util .desc_count{display:inline-block;padding:20px 0 0;font-weight:600;font-size:12px;line-height:16px;color:#888;vertical-align:top}
.area_util .desc_count em{font-weight:600;font-size:12px;line-height:16px}
.area_util .desc_count em.on{font-weight:700;color:#333} */
.area_util button{padding:10px;line-height:16px}
// .area_util button:last-child{padding-right:14px}
.area_util button:hover .icon_firfin::v-deep g{fill:#777}
.tf_has_util:focus-within .area_util{display:block}

@media (prefers-color-scheme: dark) {
  .tf_comm .inner_input{border-color:$DEFAULT_BORDER_DARK;background-color:$FORM_BG_DARK;color:$ACTIVE_TEXT_DARK}
  .tf_comm input{color:$ACTIVE_TEXT_DARK}

  /* autofill */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active{-webkit-text-fill-color: $ACTIVE_TEXT_DARK !important}

  /* placeholder */
  .tf_comm input::-webkit-input-placeholder{color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm input:-moz-placeholder{color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm input::-moz-placeholder{color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm input:-ms-input-placeholder{color:$PLACEHOLDER_TEXT_DARK}

  /* count */
  .desc_count{color:$CONTENT_SUB_TEXT_DARK}
  .desc_count em.on{color:$ACTIVE_TEXT_DARK}

  /* error focus placeholder */
  .tf_comm.tf_error:focus-within input::-webkit-input-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm.tf_error:focus-within input:-moz-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm.tf_error:focus-within input::-moz-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm.tf_error:focus-within input:-ms-input-placeholder{font-weight:500;color:$PLACEHOLDER_TEXT_DARK}

  /* disabled - placeholder */
  .tf_comm.disabled input::-webkit-input-placeholder{color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm.disabled input:-moz-placeholder{color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm.disabled input::-moz-placeholder{color:$PLACEHOLDER_TEXT_DARK}
  .tf_comm.disabled input:-ms-input-placeholder{color:$PLACEHOLDER_TEXT_DARK}

  /* disabled */
  .tf_comm.disabled:focus-within input,
  .tf_comm.disabled .inner_input{border-color:$DISABLED_BORDER_DARK;background-color:$DISABLED_BG_DARK}
  .tf_comm.disabled input:disabled{color:$DISABLED_TEXT_DARK}

  /* util */
  .area_util .icon_firfin::v-deep g{fill:#bbb}
  .area_util button:hover .icon_firfin::v-deep g{fill:#888}
}
</style>